<dialog
  #dialog
  class="animated fadeIn modal modal-bottom"
  (close)="dialogCloseHandler()">
  <ng-content></ng-content>
  @if (loading()) {
    <div
      class="layout-base absolute left-1/2 top-0 z-40 flex h-[100vh] w-full -translate-x-1/2 items-center justify-center bg-gray-600/30">
      <span class="loading loading-bars loading-lg text-primary"></span>
    </div>
  }
</dialog>
